var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNewGoalGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93198 12.2475H13.75V13.7475H0.25V10.5654L7.67462 3.14085L10.8566 6.32285L4.93198 12.2475ZM8.73528 2.08019L10.3263 0.489199C10.6192 0.196309 11.094 0.196309 11.3869 0.489199L13.5083 2.61052C13.8012 2.90341 13.8012 3.37829 13.5083 3.67118L11.9172 5.26217L8.73528 2.08019Z",
    fill: "#4D586F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNewGoalGray);
export default __webpack_public_path__ + "static/media/EditNewGoalGray.6989cd17b053b29d1bb70a8b6dfe460b.svg";
export { ForwardRef as ReactComponent };